import { ContentTypeDefault } from '../../index.h'
import type { OVPCarouselType } from '../carousels/index.h'

export enum HomeRowType {
  RECOMMENDED = 'recommended',
  FAVORITES = 'myList',
  CAROUSEL = 'carousel',
  COLLECTION = 'collection',
  CONTENT = 'content',
  TAG = 'tag',
  USER = 'user',
  REGION = 'region',
  PRIMARY_REGION = 'primaryRegion',
  CONTENT_SET = 'contentSet',
}

export interface HomeRowFilters {
  creatorId: number
}

export interface HomeRowSorting {
  sortBy?: string
  sortOrder?: string
}

export interface HomeRow {
  id: number
  rowContentType: ContentTypeDefault
  rowEntityType: HomeRowType
  rowEntityId?: number | null
  sortOrder: number
  title: string
  contentLimit?: number
  filters?: HomeRowFilters
  order?: HomeRowSorting
}

export interface HomeRows {
  carouselId: number
  carouselType: OVPCarouselType | null
  guestCarouselId: number
  guestCarouselType: OVPCarouselType | null
  rows: HomeRow[]
  pageH1: string
  backgroundImageUrl: string
  description: string
  imageAltText: string
  metaTitle: string
  metaDescription: string
}
